import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import { TiDelete } from "react-icons/ti";

const CancelFileUploadModal = ({
  isModalOpen,
  closeModal,
  cancelUpload,
  keepUploading,
}) => {
  return (
    <Modal isOpen={isModalOpen} onClose={closeModal} isCentered size={"sm"}>
      <ModalOverlay />
      <ModalContent borderRadius={"20px"} py={3} px={1}>
        <ModalHeader marginX={"auto"}>
          <TiDelete className="h-16 w-16 text-red-500" />
        </ModalHeader>
        <ModalBody display={"flex"} justifyContent={"center"}>
          <Heading width={"50%"} as="h3" size="sm" textAlign={"center"}>
            Are you sure to cancel the upload
          </Heading>
        </ModalBody>
        <ModalFooter
          display={"flex"}
          flexDirection={"column"}
          rowGap={4}
          alignItems={"center"}
        >
          <Button width={"100%"} colorScheme="red" onClick={cancelUpload}>
            Confirm Cancellation
          </Button>
          <Button width={"100%"} onClick={keepUploading} variant={"outline"}>
            Keep Uploading
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CancelFileUploadModal;
